type SocialIconName = 'facebook' | 'instagram' | 'youtube' | 'linkedin' | 'tiktok' | 'whatsapp'

type SocialIconProps = {
  name: SocialIconName
  size?: number
}

export function SocialIcon({ name, size = 18 }: SocialIconProps) {
  const commonProps = {
    'aria-hidden': true,
    className: 'social-brand-icon',
    focusable: false,
    height: size,
    viewBox: '0 0 24 24',
    width: size,
  }

  if (name === 'facebook') {
    return (
      <svg {...commonProps}>
        <path d="M14.2 8.1V6.7c0-.7.5-.9.9-.9h2.2V2.1L14.2 2c-3.5 0-4.4 2.6-4.4 4.3v1.8H7v3.8h2.8V22h4.4V11.9h3l.5-3.8h-3.5Z" />
      </svg>
    )
  }

  if (name === 'instagram') {
    return (
      <svg {...commonProps}>
        <path
          clipRule="evenodd"
          d="M7.7 2h8.6C19.5 2 22 4.5 22 7.7v8.6c0 3.2-2.5 5.7-5.7 5.7H7.7C4.5 22 2 19.5 2 16.3V7.7C2 4.5 4.5 2 7.7 2Zm8.3 2H8C5.7 4 4 5.7 4 8v8c0 2.3 1.7 4 4 4h8c2.3 0 4-1.7 4-4V8c0-2.3-1.7-4-4-4Zm-4 3.1a4.9 4.9 0 1 1 0 9.8 4.9 4.9 0 0 1 0-9.8Zm0 2a2.9 2.9 0 1 0 0 5.8 2.9 2.9 0 0 0 0-5.8Zm5-1.1a1.2 1.2 0 1 1 0-2.4 1.2 1.2 0 0 1 0 2.4Z"
          fillRule="evenodd"
        />
      </svg>
    )
  }

  if (name === 'youtube') {
    return (
      <svg {...commonProps}>
        <path d="M21.6 7.2c-.2-.8-.8-1.4-1.6-1.6C18.6 5.2 12 5.2 12 5.2s-6.6 0-8 .4c-.8.2-1.4.8-1.6 1.6C2 8.7 2 12 2 12s0 3.3.4 4.8c.2.8.8 1.4 1.6 1.6 1.4.4 8 .4 8 .4s6.6 0 8-.4c.8-.2 1.4-.8 1.6-1.6.4-1.5.4-4.8.4-4.8s0-3.3-.4-4.8ZM10 14.9V9.1l5.2 2.9-5.2 2.9Z" />
      </svg>
    )
  }

  if (name === 'linkedin') {
    return (
      <svg {...commonProps}>
        <path d="M20.5 2h-17C2.7 2 2 2.7 2 3.5v17c0 .8.7 1.5 1.5 1.5h17c.8 0 1.5-.7 1.5-1.5v-17c0-.8-.7-1.5-1.5-1.5ZM8 18.7H5V9.6h3v9.1ZM6.5 8.3c-1 0-1.7-.8-1.7-1.7s.8-1.7 1.7-1.7 1.7.8 1.7 1.7-.7 1.7-1.7 1.7Zm12.2 10.4h-3v-4.4c0-1.1 0-2.4-1.5-2.4s-1.7 1.1-1.7 2.3v4.5h-3V9.6h2.9v1.2h.1c.4-.8 1.4-1.5 2.8-1.5 3 0 3.5 2 3.5 4.5v4.9Z" />
      </svg>
    )
  }

  if (name === 'tiktok') {
    return (
      <svg {...commonProps}>
        <path d="M16.7 2c.4 3 2 4.8 5 5v3.4c-1.8.2-3.4-.4-4.9-1.5v6.4c0 8.1-8.8 10.7-12.5 4.8-2.4-3.8-.9-10.5 6.7-10.8v3.6c-.6.1-1.2.2-1.8.5-1.7.8-2.6 2.3-2.3 4 .4 3.2 6.3 4.1 5.8-2.1V2h4Z" />
      </svg>
    )
  }

  return (
    <svg {...commonProps}>
      <path d="M20.5 3.5A11.8 11.8 0 0 0 12.1 0C5.7 0 .5 5.2.5 11.6c0 2 .5 4 1.6 5.8L.4 24l6.8-1.8c1.7.9 3.6 1.4 5.5 1.4h0c6.4 0 11.6-5.2 11.6-11.6 0-3.1-1.3-6.1-3.8-8.5Zm-7.8 18.1c-1.7 0-3.3-.5-4.8-1.3l-.3-.2-4 .9.9-3.9-.2-.4c-1-1.5-1.5-3.2-1.5-5.1 0-5.1 4.2-9.3 9.3-9.3 2.5 0 4.8 1 6.6 2.8s2.8 4.1 2.8 6.6c.1 5.7-4 9.9-8.8 9.9Zm5.1-6.9c-.3-.2-1.7-.8-2-.9-.3-.1-.5-.2-.7.2-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.4-2.3-1.4-.8-.7-1.4-1.6-1.6-1.9-.2-.3 0-.5.1-.6l.5-.6c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6-.1-.2-.7-1.6-.9-2.2-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.6.1-.9.4-.3.3-1.1 1.1-1.1 2.6s1.1 3 1.2 3.2c.2.2 2.2 3.4 5.4 4.7.8.3 1.4.5 1.9.6.8.2 1.5.2 2 .1.6-.1 1.7-.7 1.9-1.3.2-.7.2-1.2.2-1.3-.1-.2-.3-.3-.6-.4Z" />
    </svg>
  )
}

export type { SocialIconName }
